import React, { Component } from 'react'
import { Grid } from 'react-styled-flexboxgrid'
import { ThemeProvider } from 'styled-components'
import { inject, observer } from 'mobx-react'

import theme from './flexBoxGridTheme'
import UserInfoRow from './UserInfoRow'
import UserInfoRowWithoutName from './UserInfoRowWithoutName'


@inject(all => ({
  columnOne: all.store.trafficLookup.columnOne
}))
@observer
class SearchFormContainer extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Grid style={{ width: '100%' }}>
          {
            this.props.columnOne === 'nameDOBGender' || this.props.columnOne === 'Name'  ? 
              <UserInfoRowWithoutName />
            : <UserInfoRow />
          }
        </Grid>
      </ThemeProvider>
    )
  }
}

export default SearchFormContainer
